import React from 'react';
import PropTypes from 'prop-types';
import Tickbox from '../Tickbox';
import { Cell } from './GenericCells';

const TickboxCell = ({
    id,
    onClick,
    style,
    disabled = false,
    value,
    size = 18,
    ...props
}) => {
    return (
        <Cell
            {...props}
            id={id}
            style={{ borderWidth: '0 1px 1px 1px', ...style }}
        >
            <Tickbox
                id={`${id}Tick`}
                size={size}
                value={value}
                onClick={onClick}
                disabled={disabled}
            />
        </Cell>
    );
};

TickboxCell.propTypes = {
    style: PropTypes.object,
    scrollPx: PropTypes.number.isRequired,
    isHighlighted: PropTypes.bool,
    index: PropTypes.number.isRequired,
    rowHeight: PropTypes.number.isRequired,
    visibleRows: PropTypes.number.isRequired,
    id: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    value: PropTypes.bool,
    size: PropTypes.number
};

export { TickboxCell };
